<template>
  <div :class="classObject()">
    <div class="container">
      <div class="share-item__wrapper">
        <block-heading
            :selector="`share-item`"
            :title="item.title"
            :text="item.text"
        />
<!--        <div class="share-item__preview" v-if="window.width >= 1200">-->
<!--          <img :src="model.image" :alt="model.name"/>-->
<!--        </div>-->
        <div class="share-item__preview">
          <img :src="model.image" :alt="model.name"/>
        </div>
        <div class="share-item__buttons" v-if="isPersonal">
          <button-theme
              :mode="`transparent`"
              :size="`s`"
              :width="229"
              :name="buttonsData.download.name"
              :label="buttonsData.download.label"
              @handleClick="handleDownload"
          />
<!--          <button-theme-->
<!--              :mode="`transparent`"-->
<!--              :size="`s`"-->
<!--              :width="229"-->
<!--              :name="buttonsData.print.name"-->
<!--              :label="buttonsData.print.label"-->
<!--              @handleClick="handlePrint"-->
<!--          />-->
<!--          <ShareNetwork-->
<!--              network="email"-->
<!--              :url="getUrl"-->
<!--              :title="emailData.title"-->
<!--              :description="emailData.description"-->
<!--              :style="{ maxWidth: '229px' }"-->
<!--          >-->
<!--            <span class="name">{{ buttonsData.send.name }}</span>-->
<!--          </ShareNetwork>-->
<!--          <button-theme-->
<!--              :mode="`transparent`"-->
<!--              :size="`s`"-->
<!--              :width="229"-->
<!--              :name="buttonsData.share.name"-->
<!--              :label="buttonsData.share.label"-->
<!--              @handleClick="handleShare"-->
<!--          />-->
        </div>
        <div class="share-item__buttons" v-else>
          <button-theme
              :mode="`transparent`"
              :size="`s`"
              :width="229"
              :name="this.$store.state.siteData.global.retailer_btn_text"
              :label="this.$store.state.siteData.global.retailer_btn_label"
              :is-disabled="true"
              @handleClick="handleFindRetailer"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import blockHeading from './blockHeading.vue';
import buttonTheme from './buttonTheme.vue';
import {mixin} from '../../mixin';

export default {
  name: 'shareItem',
  mixins: [mixin],
  props: {
    item: Object,
    isPersonal: Boolean,
  },
  components: {
    blockHeading,
    buttonTheme,
  },
  computed: {
    model() {
      return this.$store.state.selectedResult;
    },
    getUrl() {
      if (document) {
        return document.location.origin;
      }
    },
    emailData() {
      return this.$store.state.siteData.sharePersonalEmail;
    },
    buttonsData() {
      return this.$store.state.siteData.shareBtns;
    },
  },
  created() {
    if (window) {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  },
  destroyed() {
    if (window) {
      window.removeEventListener('resize', this.handleResize);
    }
  },
  methods: {
    classObject() {
      return {
        'share__item share-item': true,
        'is-personal': this.isPersonal,
        'is-retailer': !this.isPersonal,
      };
    },
    handleDownload() {
      this.$emit('handleDownload');
    },
    // handlePrint() {
    //   this.$emit('handlePrint');
    // },
    // handleShare() {
    //   this.$emit('handleShare');
    // },
    handleFindRetailer() {
      this.$emit('handleFindRetailer');
    },
  },
};
</script>

<style lang="scss">
@import '../../../sass/setup.scss';

.share-item {
  flex-grow: 1;
  width: 100%;
  text-align: center;

  display: flex;
  align-items: center;

  //@include up-tablet {
  //  display: flex;
  //  align-items: center;
  //}

  @include up-laptop {
    align-items: flex-start;
  }

  &.is-personal {
    padding: 100px 12px 68px;
    background-color: $c-light-beige;

    @include up-tablet {
      padding: 84px 0;
    }

    @include up-laptop {
      //padding: 12.0625vh 0 6.0625vh;
      padding: 12.0625vh 0;
    }

    //@media (min-width: 1440px) {
    //  padding: 14.0625vh 0;
    //}

    @media (min-width: 1920px) {
      padding: 144px 0;
    }
  }

  &.is-retailer {
    padding: 87px 12px;

    @include up-tablet {
      padding: 84px 0;
    }

    @include up-laptop {
      //padding: 12.0625vh 0 6.0625vh;
      padding: 12.0625vh 0;
    }

    //@media (min-width: 1440px) {
    //  padding: 14.0625vh 0;
    //}

    @media (min-width: 1920px) {
      padding: 144px 0;
    }
  }

  &__wrapper {
    @include up-laptop {
      display: grid;
      grid-template-columns: 100%;
      grid-template-rows: auto calc(1.4em + 50px) auto 1fr;
    }

    @media (min-width: 1550px) {
      grid-template-rows: auto calc(2.4em + 50px) auto 1fr;
    }
  }

  &__heading {
    margin-bottom: 4px;

    @include up-tablet {
      margin-bottom: 10px;
      max-width: 556px;
    }

    @include up-desktop {
      margin-bottom: 23px;
    }
  }

  &__text {
    margin-bottom: 29px;
    max-width: 381px;

    @include up-tablet {
      margin-bottom: 31px;
    }

    @include up-laptop {
      margin-bottom: 3.8828vh;
    }

    @media (min-width: 1550px) {
      margin-bottom: 4.8828vh;
      //margin-bottom: 50px;
    }
  }

  &__preview {
    //margin: 0 auto 89.04px;
    //width: 29.2361vw;
    margin: -20px auto 39.04px;
    width: 59.2361vw;

    @include up-laptop {
      margin-bottom: 3.8828vh;
      width: 34.2361vh;
    }

    @media (min-width: 1550px) {
      margin-bottom: 4.8828vh;
      //margin-bottom: 50px;
    }

    img {
      width: 100%;
      height: auto;
    }
  }

  &__buttons {
    margin: auto;
    display: grid;
    grid-template-columns: 100%;
    grid-row-gap: 10px;

    @include up-tablet {
      grid-row-gap: 15px;
    }

    & > * {
      margin: auto;

      @include up-laptop {
        min-width: 229px;
      }
    }
  }
}
</style>
